import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d352b98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quality-wrap" }
const _hoisted_2 = { class: "ul" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "整改单号：", -1))
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "任务名称：", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检查内容：", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检查人：", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "整改人：", -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开始时间：", -1))
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "完成期限：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_sticky, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_search, {
          modelValue: _ctx.searchName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchName) = $event)),
          shape: "round",
          placeholder: "搜索检查单号、任务名称、检查项目、检查人",
          onBlur: _ctx.onSearch
        }, null, 8, ["modelValue", "onBlur"]),
        _createVNode(_component_van_tabs, {
          onClickTab: _ctx.onClickTab,
          active: _ctx.vantActive,
          "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vantActive) = $event)),
          color: "#3d6eeb",
          "title-active-color": "#3d6eeb"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_tab, { title: "需整改" }),
            _createVNode(_component_van_tab, { title: "已结束" }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.endTabList, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.value,
                      onClick: ($event: any) => (_ctx.clickEndTab(item.value)),
                      class: _normalizeClass(item.value === _ctx.endTabActive && 'active')
                    }, _toDisplayString(item.label), 11, _hoisted_3))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClickTab", "active"])
      ]),
      _: 1
    }),
    (_ctx.pageData.list.length)
      ? (_openBlock(), _createBlock(_component_van_list, {
          key: 0,
          loading: _ctx.pageData.loading,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageData.loading) = $event)),
          finished: _ctx.pageData.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad,
          class: "quality-list"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData.list, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "quality-list-item",
                key: item.id,
                onClick: ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.QUALITY_RECTIFICATION_DETAIL,
            query: { id: item.id }
          })
        )
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.obj_name), 1),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(_toDisplayString(item.orderid || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode(_toDisplayString(item.pool_name || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(_toDisplayString(item.norm_title || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode(_toDisplayString(item.handler_user_info?.name || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createTextVNode(_toDisplayString(item.liable_user_info?.name || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createTextVNode(_toDisplayString(item.create_time_name || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(_toDisplayString(item.reform_over_time_name || "不限"), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(['state', `state${item.state}`])
                }, _toDisplayString(item.state_name), 3)
              ], 8, _hoisted_4))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"]))
      : (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          class: "empty-image",
          image: require('../../assets/empty@2x.png'),
          description: "暂无数据"
        }, null, 8, ["image"]))
  ]))
}